<div class="search-filter">
    <div class="filter-header">
        <h1>Filter</h1>
        <div class="sub-title">Marked</div>
        <div class="right-align">
            @if (showHardResetButton()) {
                <span class="icon reset" title="Tilbakestill til standard filter oppsett" (click)="onResetToStandardFilter()"></span>
            }
            <div class="close-filter-button" (click)="onCloseFilter()"></div>
        </div>
    </div>
    <estate-filter-bar [scrolled]="isFieldListScrolled()"></estate-filter-bar>
    <estate-filter-fields (scrolled)="isFieldListScrolled.set($event)"></estate-filter-fields>
</div>
